/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Type_LabelInputs */

const en_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const it_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ru_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const zh_cn2_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ja_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const hi_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const pt_pt2_explorer_search_type_label = /** @type {(inputs: Explorer_Search_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Explorer_Search_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_type_label = /** @type {((inputs?: Explorer_Search_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_type_label(inputs)
	if (locale === "de") return de_explorer_search_type_label(inputs)
	if (locale === "it") return it_explorer_search_type_label(inputs)
	if (locale === "ru") return ru_explorer_search_type_label(inputs)
	if (locale === "es") return es_explorer_search_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_type_label(inputs)
	if (locale === "ja") return ja_explorer_search_type_label(inputs)
	if (locale === "hi") return hi_explorer_search_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_type_label(inputs)
	return en_explorer_search_type_label(inputs)
});